<div class="quick-entity-chips">
	<entity-priority
		[selectedPriority]="priority()"
		[showAsChip]="true"
		(priorityChanged)="priority.set($event)"
	/>

	<entity-responsible
		[selectedResponsible]="assignee()"
		[showAsChip]="true"
		(responsibleChanged)="assignee.set($event)"
	/>

	<entity-labels-section
		[selectedLabels]="labels()"
		[showAsChip]="true"
		(labelsChanged)="labels.set($event)"
	/>

	<entity-category
		[selectedCategory]="category()"
		[showAsChip]="true"
		(categoryChanged)="category.set($event)"
	/>
</div>
